import { FlexBox, Icon, MediaPlayer, Text } from '@dixa/lib-shared-habla';

import styles from './listItem.module.scss';

export type Item = {
  isRecurring: boolean;
  name: string;
  value: {
    announcement?: string;
    label: string;
  };
};

export type ListItemProps = {
  isBold?: boolean;
  isLoading: boolean;
  item: Item;
  withBackground?: boolean;
};

export function ListItem({
  isBold,
  isLoading,
  item,
  withBackground = true,
}: ListItemProps): JSX.Element {
  const { name, isRecurring, value } = item;
  const { announcement, label } = value;

  return (
    <>
      <FlexBox alignItems="center">
        <Text.Paragraph variant={isBold ? '1' : '2'}>{name}</Text.Paragraph>
        {isRecurring && <Icon name="sync" className={styles.recurringIcon} />}
      </FlexBox>
      <FlexBox
        gap="300"
        flex="1"
        height="48px"
        justifyContent="space-between"
        alignItems="center"
        borderRadius="100"
        padding="100 300 100 0"
        {...(withBackground && {
          background: 'neutral.000',
          padding: '100 300',
        })}
      >
        <Text.Paragraph
          variant="2"
          className={styles.label}
          subdued={!withBackground}
        >
          {isLoading ? 'Loading...' : label}
        </Text.Paragraph>
        {!!announcement && (
          <MediaPlayer
            className={styles.mediaPlayer}
            mediaFile={{ src: announcement, type: 'audio' }}
            controls={{
              download: false,
              volume: false,
            }}
          />
        )}
      </FlexBox>
    </>
  );
}
